import {Component, ElementRef, HostListener, Input} from '@angular/core';

@Component({
    selector: 'buildings',
    templateUrl: './buildings.component.html',
    styleUrls: ['./buildings.component.scss']
})
export class BuildingsComponent {
    @Input() data: Array<any> = [];

    public isShow: boolean = false;

    constructor(private elementRef: ElementRef) {}

    get value() {
        if (this.data && this.data.length) {
            return this.data.reduce((hoarder, item) => {
                return hoarder + (item.building ? item.building.name + ', ' : '');
            }, '').trim().slice(0, -1);
        }

        return '';
    }

    toggleDetails() {
        this.isShow = !this.isShow;
    }

    @HostListener('document:click', ['$event.target'])
    private hide(targetElement: HTMLElement): void {
        if (!this.elementRef.nativeElement.contains(targetElement)) {
            this.isShow = false;
        }
    }

}



// WEBPACK FOOTER //
// /app/src/app/views/admin/user/buildings/buildings.component.ts